<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <!-- <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.offlinemerchant_delete"
          @click="handleDelete"
          >删 除
        </el-button> -->
      </template>
      <template slot-scope="{ row }" slot="status">
        <el-tag
          style="font-size: 14px; width: 60px; height: 30px; line-height: 32px; text-align: center"
          :type="row.status === 0 ? 'danger' : 'success'"
        >
          {{ row.status === 0 ? '禁用' : '启用' }}</el-tag
        >
      </template>

      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit-outline"
          @click.native="changeStatus(scope.row)"
          >{{ getLabelName(scope.row.status) }}
        </el-button>

        <el-button
          type="text"
          size="small"
          icon="el-icon-edit-outline"
          @click="openComment(scope.row)"
          >评论管理
        </el-button>

        <el-button
          type="text"
          size="small"
          icon="el-icon-edit-outline"
          @click="openGoods(scope.row)"
          >商品管理
        </el-button>
      </template>

      <template slot="storeAttachListForm">
        <VUpload :fileList.sync="storeAttachList" :disabled="dialogType == 'view'" />
      </template>
      <template slot="qualificationAttachListForm">
        <VUpload :fileList.sync="qualificationAttachList" :disabled="dialogType == 'view'" />
      </template>
    </avue-crud>

    <!-- 弹框 -->
    <hr-dialog
      title="评价管理"
      :allowFull="false"
      width="60%"
      @close="closeAddCommentDialog"
      :visible.sync="commentFormVisible"
    >
      <template slot="body">
        <comment
          :row="formRow"
          @success="recordSuccess"
          @cancle="recordCancle"
          v-if="commentFormVisible"
        ></comment>
      </template>
    </hr-dialog>
    <hr-dialog
      title="商品管理"
      :allowFull="false"
      width="60%"
      @close="closeAddServiceDialog"
      :visible.sync="serviceFormVisible"
    >
      <template slot="body">
        <goods
          :row="formRow"
          @success="recordSuccess"
          @cancle="recordCancle"
          v-if="serviceFormVisible"
        ></goods>
      </template>
    </hr-dialog>
  </basic-container>
</template>

<script>
import comment from './comment.vue';
import goods from './goods.vue';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  updateStatus,
} from '@/api/v4ward/offline/merchant/offlinemerchant';
import { mapGetters } from 'vuex';
import VUpload from '@/views/components/v-upload';

export default {
  components: {
    VUpload,
    goods,
    comment,
  },
  data() {
    return {
      commentFormVisible: false,
      serviceFormVisible: false,
      storeAttachList: [],
      qualificationAttachList: [],
      form: {},
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        menu: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        tip: false,
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        indexLabel:'序号',
        viewBtn: true,
        selection: false,
        searchLabelWidth: 100,
        labelWidth: 100,
        dialogClickModal: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '门店名称',
            span: 8,
            maxlength:10,
            showWordLimit: true,
            prop: 'name',
            rules: [
              {
                required: true,
                message: '请输入门店名称',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '门店类型',
            span: 8,
            prop: 'type',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=offline_merchant_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入门店类型',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '服务类型',
            prop: 'serviceType',
            span: 8,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=offline_merchant_service_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入服务类型',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '门店地址',
            prop: 'address',
            maxlength:10,
            showWordLimit: true,
            span: 8,
            rules: [
              {
                required: false,
                message: '请输入商家地址',
                trigger: 'change',
              },
            ],
          },
          {
            label: '负责人',
            prop: 'contactName',
            maxlength:10,
            showWordLimit: true,
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入负责人',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '联系电话',
            span: 8,
            prop: 'contactPhone',
            rules: [
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'change',
              },
              {
                pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                message: '请输入正确的联系电话',
                trigger: 'blur',
              },
            ],
            search: true,
          },
          {
            label: '经营范围介绍',
            type: 'textarea',
            prop: 'businessScope',
            maxlength:200,
            showWordLimit: true,
            hide: true,
            span: 24,
            rules: [
              {
                required: false,
                message: '请输入经营范围介绍',
                trigger: 'change',
              },
            ],
            labelWidth: 120,
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            slot: true,
            dicData: [
              { label: '禁用', value: 0 },
              { label: '启用', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择状态',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '门店资质',
            prop: 'qualificationAttachList',
            showColumn: false,
            formslot: true,
            span: 12,
          },
          {
            label: '商家图片',
            prop: 'storeAttachList',
            showColumn: false,
            formslot: true,
            span: 12,
          },
          {
            label: '其他服务',
            prop: 'otherService',
            span: 24,
            type: 'textarea',
            maxlength:200,
            showWordLimit: true,
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入其他服务',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.offlinemerchant_add, true),
        viewBtn: this.vaildData(this.permission.offlinemerchant_view, true),
        delBtn: this.vaildData(this.permission.offlinemerchant_delete, false),
        editBtn: this.vaildData(this.permission.offlinemerchant_edit, true),
      };
    },

    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    openComment(row) {
      this.formRow = row;
      this.commentFormVisible = true;
    },
    openGoods(row) {
      this.formRow = row;
      this.serviceFormVisible = true;
    },
    recordSuccess() {
      this.serviceFormVisible = false;
      this.commentFormVisible = false;

      this.onLoad();
    },
    recordCancle() {
      this.serviceFormVisible = false;
      this.commentFormVisible = false;
    },
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 390; // 表格区域初始化高度
      const searchH = 110; // 搜索区域占的高度
      this.option.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.option.height == tableInitH) {
              this.option.height = tableInitH + searchH;
            } else {
              this.option.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    changeStatus(row) {
      let status = row.status === 1 ? 0 : 1;
      let label = '确认禁用此组件?';
      if (status === 1) {
        label = '确认启用此组件?';
      }
      this.$confirm(label, {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).then(() => {
        // eslint-disable-next-line no-unused-vars
        updateStatus(row).then((res) => {
          row.status = status;
          this.$message.success('操作成功!');
        });
      });
    },
    getLabelName(status) {
      if (status === 1) {
        return '禁用';
      } else {
        return '启用';
      }
    },
    rowSave(row, done, loading) {
      row.qualificationAttachList = this.qualificationAttachList;
      row.storeAttachList = this.storeAttachList;
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.qualificationAttachList = this.qualificationAttachList;
      row.storeAttachList = this.storeAttachList;
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.dialogType = type;
      this.storeAttachList = [];
      this.qualificationAttachList = [];
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
          this.storeAttachList = data.storeAttachList;
          this.qualificationAttachList = data.qualificationAttachList;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script >

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>